import React from 'react';
import { UncontrolledAlert } from 'reactstrap';

function AlertExample() {
  return (
    <UncontrolledAlert color="info">
      I am an alert and I can be dismissed!
    </UncontrolledAlert>
  );
}

export default AlertExample;



// WEBPACK FOOTER //
// ./docs/lib/examples/AlertUncontrolledDismiss.js